import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { PaginatedResponse } from '@app/entity';
import { Coupon, CouponStatus } from '@app/entity/coupon';
import { API_VERSION } from '@app/core/api.version';

export interface CouponFilters {
  status?: CouponStatus;
  uuid?: string;
}

@Injectable()
export class CouponsService {

  constructor(private http: HttpClient) {
  }

  getOwnCoupons(filters: CouponFilters): Observable<PaginatedResponse<Coupon>> {
    let params = new HttpParams();
    if (filters && filters.status) params = params.set('status', filters.status);
    if (filters && filters.uuid) params = params.set('uuid', filters.uuid);
    return this.http.get<PaginatedResponse<Coupon>>(`/${API_VERSION}/coupons/`, { params });
  }

  createCoupon(data: Coupon): Observable<Coupon> {
    return this.http.post<Coupon>(`/${API_VERSION}/coupons/`, data);
  }


  getCouponByUUID(uuid: string): Observable<Coupon> {
    return this.getOwnCoupons({uuid: uuid})
      .map(res => res.results[0]);
  }

  getCoupon(id: string): Observable<Coupon> {
    return this.http.get<Coupon>(`/${API_VERSION}/coupons/${id}/`);
  }

  closeCoupon(coupon: Coupon): Observable<Coupon> {
    if (!coupon) return;
    return this.http.post<Coupon>(`/${API_VERSION}/coupons/${coupon.id}/set_used/`, {});
  }

  getCouponPDF(coupon: Coupon): Observable<string> {
    if (!coupon) return Observable.of(null);

    return this.http.get<{ print_url: string }>(`/${API_VERSION}/coupons/${coupon.id}/get_print_url/`)
      .map(response => response.print_url);
  }

  sendEmail(id: string): Observable<Object> {
    return this.http.post(`/${API_VERSION}/coupons/${id}/send_to_email/`, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/coupons.service.ts